import { useNavigate } from "react-router-dom";
import axios from "../../../../../axios";
import React from "react";
import { toast } from "react-toastify";
// css comes in confirmActivity.css

const Cnfirm_Delete_Published = ({ setDelete, activity_id, activitys }) => {
  let Teacher_id = localStorage.getItem("Teacher_id");
  let Teacher_Json = JSON.parse(Teacher_id);
  let teacher_id = Teacher_Json;
  const navigate = useNavigate();

  const publishedDelete = async () => {
    try {
      let res = await axios.delete(
        `/api/v1/homework/activity/delete/${activity_id}`,
        {
          data: { teacher_id },
        }
      );

      if (res) {
        setDelete(false);
        toast.success("Activity Deleted Successfully");
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong");
    }
  };
  // console.log(publishedDelete);
  return (
    <>
      <div className=" delete_activity_transprant_body ">
        <img
          src="/images/cross-circle3.svg"
          className="delete_activity_close_btn"
          alt=""
          onClick={(e) => setDelete(false)}
        />
        <div className=" p-3 d-flex align-items-center justify-content-center flex-column delete_activity_container shadow">
          {/* <div className="gap-2 mb-5 d-flex align-items-center justify-content-center">
            <img
              className="activity_img"
              src="/images/ActivityProps.png"
              alt=""
            />
            <span>{activitys?.name}</span>
          </div> */}
          <div className=" col-12 d-flex align-items-center justify-content-center flex-column text-center">
            <span className="mb-3">
              Are you sure you want to delete this activity?
            </span>
            <div className="col-12 p-0 gap-3 flex-wrap d-flex justify-content-center ">
              <button
                className="btn btn-danger col-sm-5  delete_btn"
                onClick={publishedDelete}
              >
                Yes
              </button>
              <button
                className="btn btn-danger col-sm-5 delete_btn"
                autoFocus
                onClick={(e) => setDelete(false)}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Cnfirm_Delete_Published;
